module.exports = __webpack_public_path__ + "media/Group1.1a238951.mp3";